import request from "superagent";

import config from "config/config";
import { getTabToken } from "common/MetaActions";
import { DeliveryFile } from "models/DeliveryFile";
import { ArchiveItem } from "models/ArchiveItem";
import { DeliveryUploadFile } from "views/delivery/containers/DocumentDeliveryUpload";

export class DeliveryAPI {
  static async fetchUploadedFiles(customerId: string) {
    const response = await request
      .get(config.api.file.get + customerId)
      .set("Accept", "application/json")
      .set("Authorization", `Bearer ${getTabToken()}`)
      .send({
        CustomerId: customerId
      });

    const result = JSON.parse(response.text);

    return result.items;
  }

  static async setFileAsHandled(
    itemToHandle: DeliveryFile,
    customerId: string
  ) {
    const response = await request
      .post(config.api.file.setHandled())
      .set("Accept", "application/json")
      .set("Authorization", `Bearer ${getTabToken()}`)
      .send({
        CustomerId: customerId,
        FileIds: [itemToHandle.id]
      });

    return response;
  }

  static async moveToArchive(
    item: ArchiveItem | DeliveryFile,
    customerId: string,
    path: string,
    name: string
  ) {
    const response = await request
      .post(config.api.file.moveToArchive(customerId, item.id))
      .set("Accept", "application/json")
      .set("Authorization", `Bearer ${getTabToken()}`)
      .send({
        customerId,
        path,
        fileId: item.id,
        name
      });

    return response;
  }

  static async sendFile(file: DeliveryUploadFile, customerId: string) {
    const formData = new FormData();
    formData.append("File", file.file);
    formData.append("Category", file.meta.category || "Okategoriserad");
    formData.append("Comment", file.meta.comment || "");

    const response = await request
      .post(config.api.file.postV2(customerId))
      .set("Accept", "application/json")
      .set("Authorization", `Bearer ${getTabToken()}`)
      .send(formData);

    const newItem = JSON.parse(response.text) as DeliveryFile;
    return newItem;
  }

  static async deleteDocuments(customerId: string, fileId: string) {
    const response = await request
      .delete(config.api.externalUserFiles.deleteFile(customerId, fileId))
      .set("Authorization", `Bearer ${getTabToken()}`);

    return response;
  }
}
